module.exports = __webpack_public_path__ + "static/media/sorry.3f0da4a1.svg";